import { useState, useEffect } from "react";
import { Phone, Menu, X } from "lucide-react";
import { BUSINESS } from "@/data";
import {
  Sheet, SheetContent, SheetTrigger,
} from "@/components/ui/sheet";

const LINKS = [
  { label: "Services", id: "services" },
  { label: "Pricing", id: "pricing" },
  { label: "Service Area", id: "areas" },
  { label: "Gallery", id: "gallery" },
  { label: "Reviews", id: "reviews" },
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-50 border-b border-black bg-white/95 backdrop-blur transition-[padding] duration-300 ${scrolled ? "py-2" : "py-4"}`}
    >
      <div className="mx-auto flex max-w-[1400px] items-center justify-between px-4 sm:px-8">
        <button
          data-testid="nav-logo"
          onClick={() => scrollTo("top")}
          className="font-anton text-xl sm:text-2xl uppercase tracking-tight leading-none text-left"
        >
          Moe's Dump <span className="text-[#FF4E00]">&</span> Junk
        </button>

        <nav className="hidden items-center gap-8 md:flex">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => scrollTo(l.id)}
              className="text-xs font-bold uppercase tracking-[0.15em] text-black transition-colors hover:text-[#FF4E00]"
            >
              {l.label}
            </button>
          ))}
          <a
            data-testid="nav-call-btn"
            href={`tel:${BUSINESS.phoneRaw}`}
            className="flex items-center gap-2 bg-black px-5 py-3 text-xs font-bold uppercase tracking-[0.15em] text-white transition-colors hover:bg-[#FF4E00]"
          >
            <Phone size={14} /> {BUSINESS.phone}
          </a>
        </nav>

        <div className="md:hidden">
          <Sheet open={open} onOpenChange={setOpen}>
            <SheetTrigger asChild>
              <button data-testid="nav-menu-btn" aria-label="Open menu" className="p-2 min-h-[44px] min-w-[44px] flex items-center justify-center">
                <Menu size={26} />
              </button>
            </SheetTrigger>
            <SheetContent side="right" className="rounded-none border-l-2 border-black bg-white w-[80%]">
              <div className="mt-8 flex flex-col gap-2">
                {LINKS.map((l) => (
                  <button
                    key={l.id}
                    data-testid={`mobile-nav-link-${l.id}`}
                    onClick={() => scrollTo(l.id)}
                    className="border-b border-black/10 py-4 text-left font-anton text-2xl uppercase"
                  >
                    {l.label}
                  </button>
                ))}
                <a
                  data-testid="mobile-nav-call-btn"
                  href={`tel:${BUSINESS.phoneRaw}`}
                  className="mt-4 flex items-center justify-center gap-2 bg-[#FF4E00] px-5 py-4 font-bold uppercase tracking-wide text-white"
                >
                  <Phone size={16} /> Call {BUSINESS.phone}
                </a>
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
};
